import React, { useEffect } from 'react';
import { DataTable } from '../../Table/Table.jsx';
import { Footer } from '../../Footer/Footer.jsx';
import { confirmationMessages } from '../../messages/commonMessages.jsx';
import { CustomDialog } from '../../messages/CustomDialog.jsx';
import '../../../App.css'
import { AlertDialog } from '../../messages/AlertDialog.jsx';
import { Alert } from '../../messages/Alert.jsx';
import Tooltip from '@mui/material/Tooltip';
import { Formulario } from './Formulario/Formulario.jsx';
import { useCodigoRespuesta } from './useCodigoRespuesta.js';

const MantenimientoCodigoRespuesta = () => {

    const { handleRowSelectionChange, handleSave, handleCloseDialog, handleGenerateReport,
         columnas, isDialogOpen, isEdit, isView, isAdd, alert, handleAdd, handleDeleteData, 
         handleCancel, getCodigos, isDelete, selectedRow, data } = useCodigoRespuesta();

    useEffect(() => {
        getCodigos();
    }, []);

    return (
        <div className='content-wrapper'>
            {alert && (
                <Alert
                    severity={alert.severity}
                    title={alert.title}
                >
                    {alert.message}
                </Alert>
            )}
            <div className="wrapper-card">
                <h1>
                    Mantenimiento Códigos de Respuesta
                </h1>
                <div className='form-container'>
                    <div className="content">
                        <div className='form-container'>
                            <div className="title">
                                Lista de Códigos de Respuesta
                            </div>
                            <div className="content">
                                <DataTable
                                    data={data && Array.isArray(data) ? data.map(row => ({ id: row.idCodRespuesta, ...row })) : []}
                                    columns={columnas}
                                    onRowSelectionChange={handleRowSelectionChange} >
                                    {data === null && (
                                        <div style={{ textAlign: 'center', padding: '20px' }}>
                                            Cargando datos...
                                        </div>
                                    )}
                                </DataTable>
                                <div className='button-action'>
                                    <Tooltip title="Agregar">
                                        <button className="action-button" onClick={handleAdd}>Agregar</button>
                                    </Tooltip>
                                    {isDialogOpen && isAdd && (
                                        <CustomDialog
                                            question={'Agregar Código de Respuesta'}
                                            message={<Formulario onSave={handleSave} onCancel={handleCancel} codigo={selectedRow} render={'Add'} />}
                                            onClose={handleCloseDialog}
                                        />
                                    )}
                                    {isDialogOpen && isEdit && (
                                        <CustomDialog
                                            question={'Modificar Código de Respuesta'}
                                            message={<Formulario onSave={handleSave} onCancel={handleCancel} codigo={selectedRow} render={'Edit'} />}
                                            onClose={handleCloseDialog}
                                        />
                                    )}
                                    {isDialogOpen && isView && (
                                        <CustomDialog
                                            question={'Consultar Código de Respuesta'}
                                            message={<Formulario onSave={handleSave} onCancel={handleCancel} codigo={selectedRow} render={'View'} />}
                                            onClose={handleCloseDialog}
                                        />
                                    )}
                                    {isDialogOpen && isDelete && (
                                        <AlertDialog
                                            question={"Eliminar Código de Respuesta"}
                                            message={confirmationMessages.DELETE_CONFIRMATION_CODIGO}
                                            isOpen={isDialogOpen}
                                            onClose={handleCloseDialog}
                                            onAccept={handleDeleteData}
                                            onCancel={handleCancel}
                                        />
                                    )}
                                    <Tooltip title="Generar Reporte">
                                        <button className="action-button" onClick={handleGenerateReport}>Generar Reporte</button>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export { MantenimientoCodigoRespuesta };